var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyedReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#16304F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 18.6667V17M13.8333 18.6667V15.3333M16.3333 18.6667V13.6667M18 22H9.66667C9.22464 22 8.80072 21.8244 8.48816 21.5118C8.17559 21.1993 8 20.7754 8 20.3333V8.66667C8 8.22464 8.17559 7.80072 8.48816 7.48816C8.80072 7.17559 9.22464 7 9.66667 7H14.3217C14.5427 7.00005 14.7546 7.08788 14.9108 7.24417L19.4225 11.7558C19.5788 11.9121 19.6666 12.124 19.6667 12.345V20.3333C19.6667 20.7754 19.4911 21.1993 19.1785 21.5118C18.866 21.8244 18.442 22 18 22Z",
    stroke: "#3FE13A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyedReportIcon);
export default __webpack_public_path__ + "static/media/greyed-report-icon.2c00d6995864bcafd92ae41dc17e3f1d.svg";
export { ForwardRef as ReactComponent };